import React from "react";
const ActiveUserIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15986_106522)">
        <path
          d="M5.33268 10.0003L9.33268 13.3337L14.666 6.66699M9.99935 19.3337C8.77368 19.3337 7.56001 19.0922 6.42764 18.6232C5.29526 18.1542 4.26637 17.4667 3.39969 16.6C2.53301 15.7333 1.84552 14.7044 1.37647 13.572C0.907429 12.4397 0.666016 11.226 0.666016 10.0003C0.666016 8.77465 0.907429 7.56099 1.37647 6.42861C1.84552 5.29624 2.53301 4.26734 3.39969 3.40066C4.26637 2.53398 5.29526 1.84649 6.42764 1.37745C7.56001 0.908406 8.77368 0.666992 9.99935 0.666992C12.4747 0.666992 14.8487 1.65032 16.599 3.40066C18.3494 5.151 19.3327 7.52497 19.3327 10.0003C19.3327 12.4757 18.3494 14.8496 16.599 16.6C14.8487 18.3503 12.4747 19.3337 9.99935 19.3337Z"
          stroke="#70B50E"
        />
      </g>
      <defs>
        <clipPath id="clip0_15986_106522">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ActiveUserIcon;
